<template>
  <div class="invite-page" @click="onLinkClicked">
    <div class="invite-header">
      <img class="invite-logo" src="@/assets/img/fam-logo.png" />
      <span class="invite-header-text">{{ inviteText }}</span>
      <svg class="invite-caret-icon" stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 320 512" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z"></path></svg>
    </div>
    <div class="invite-main">
      <img src="@/assets/img/invite-bg.png" class="invite-background"/>
      <img :src="viewProfilePhotoUrl" class="invite-photo" />
      <img src="@/assets/img/invite-front.png" class="invite-front" />
    </div>
    <div class="invite-main-text">
      <span>{{ viewInviterName }} invited you to<br>
        <img class="invite-text-logo" src="@/assets/img/fam-logo-transparent.png" />
        get lit with them on Fam
      </span>
    </div>
    <div class="invite-bottom">
      <div class="invite-button">Get Lit 🔥</div>
    </div>
  </div>
</template>
<script>
import { nanoid } from 'nanoid';
import { firebase, rtdb } from '@/vendors/firebase/firebase';
import ls from 'local-storage';

const UNKNOWN_INVITER = 'Somebody';

export default {
  props: {
    inviterId: { type: String, required: true },
    profilePhotoUrl: { type: String },
    inviterName: { type: String },
  },
  async mounted() {
    if (this.profilePhotoUrl) {
      this.viewProfilePhotoUrl = this.profilePhotoUrl;
    }
    if (this.inviterName) {
      this.viewInviterName = this.inviterName;
    }
  },
  data() {
    return {
      // eslint-disable-next-line
      viewProfilePhotoUrl: require('@/assets/img/profile-placeholder.png'),
      viewInviterName: UNKNOWN_INVITER,
      friendCount: 4 + this.randomInRange(6),
    };
  },
  computed: {
    inviteText() {
      if (this.viewInviterName === UNKNOWN_INVITER) {
        return `${this.friendCount} friends are using Fam to get lit with friends 🔥`;
      }
      return `${this.viewInviterName} and ${this.friendCount} other friends are using Fam to get lit with friends 🔥`;
    },
  },
  methods: {
    async onLinkClicked() {
      const sessionId = this.getSessionId() || nanoid();

      this.setSessionId(sessionId);
      await rtdb.ref('inviteLinkClicks')
        .child(this.inviterId)
        .child(sessionId)
        .set({
          sessionId,
          clickedAt: firebase.database.ServerValue.TIMESTAMP,
        });
      this.redirect();
    },
    redirect() {
      window.location.href = `https://getchannels.app.link/8xnnSSfDh5?$custom_meta_tags=${this.inviterId}`;
    },
    getSessionId() {
      return ls.get('session_id');
    },
    setSessionId(id) {
      return ls.set('session_id', id);
    },
    randomInRange(max) {
      return Math.round(Math.random() * (max - 1));
    },
  },
};
</script>
<style lang="stylus">

@font-face {
  font-family: "MuseoSansRounded";
  font-weight: 700;
  src: url(../../assets/fonts/MuseoSansRounded-700.otf) format('truetype');
}

@font-face {
  font-family: "MuseoSansRounded";
  font-weight: 900;
  src: url(../../assets/fonts/MuseoSansRounded-900.otf) format('truetype');
}

.invite-page {
  background-color: #fff;
  display: grid;
  font-family: MuseoSansRounded;
  grid-template-rows: 10vh 45vh 12vh 25vh;
  width: 100%;
}
.invite-header {
  box-shadow: 0.1em 0.1em 0.5em #ababab;
  align-items: center;
  background-color: #f5f5f5;
  display: grid;
  grid-template-columns: 2.5fr 10fr 2fr;
}
.invite-logo {
  border-radius: 16px;
  height: 6vh;
  margin: 1vh 2vw;
  object-fit: scale-down;
  box-shadow: 0.1em 0.1em 0.5em #ababab;
}
.invite-header-text {
  font-size: 4.5vw;
}

.invite-main {
  border: none;
  font: inherit;
  font-size: 100%;
  margin: 0;
  padding: 0;
  vertical-align: baseline;
}

.invite-background {
  left: 0;
  margin-left: auto;
  margin-right: auto;
  object-fit: scale-down;
  position: absolute;
  right: 0;
  height: 35vh;
  top: 20vh;
}

.invite-photo {
  height: 12vh;
  left: 0;
  margin-left: auto;
  margin-right: auto;
  object-fit: scale-down;
  position: absolute;
  right: 0;
  top: 34.5vh;
}

.invite-front {
  height: 10vh;
  top: 44vh;
  left: 0;
  margin-left: auto;
  margin-right: auto;
  object-fit: scale-down;
  position: absolute;
  right: 0;
}

.invite-caret-icon {
  color: #ccc;
  font-size: 3vh;
  justify-self: center;
}

.invite-main-text {
  font-size: 2.5vh;
  padding: 2vh 3vw;
  text-align: center;
  vertical-align: baseline;
}

.invite-text-logo {
  height: 3vh;
  margin: 0 2vw;
  object-fit: scale-down;
  position: relative;
  top: .8vh;
}

.invite-text {
  border: none;
  font: inherit;
  font-size: 100%;
  margin: 0;
  padding: 0;
  vertical-align: baseline;
}

.invite-bottom {
  justify-self: center;
}

.invite-button {
  border-radius: 10vw;
  font-size: 2.5vh;
  padding: 2vh 8vw;
  text-align: center;
  background-color: #00c3ff;
  color: #fff;
}
</style>
